import { Controller } from "@hotwired/stimulus"

const REF_SEPARATOR = /[\s,]+/

export default class extends Controller {
  static targets = ["input", "count", "submit"]
  static values = { max: Number }

  connect() {
    this.update()
  }

  update() {
    const count = this.refCount()
    const overLimit = count > this.maxValue

    this.countTarget.textContent = `${count} of ${this.maxValue} references`
    this.countTarget.classList.toggle("text-danger", overLimit)
    this.submitTarget.disabled = overLimit
  }

  validate(event) {
    if (this.refCount() <= this.maxValue) return

    event.preventDefault()
    this.update()
  }

  refCount() {
    return this.inputTarget.value.split(REF_SEPARATOR).filter(Boolean).length
  }
}
